import axios from 'axios';
import { isTokenValid } from '../../../utils/index';

// Create an Axios instance with base URL and any other default config
const tenantAxiosInstance = axios.create();

// Add an interceptor to attach the authentication header
tenantAxiosInstance.interceptors.request.use((config) => {
  const authToken = JSON.parse(sessionStorage.getItem('brandUser'))?.access_token;
  if (authToken) {
    config.headers['Authorization'] = `Bearer ${authToken}`;
  }
  return config;
});
const isProdEnv =
  process.env.REACT_APP_ENV === 'PRODUCTION' ||
  // process.env.NODE_ENV === 'production' ||
  window.location.hostname === 'brandastra.ai';

const pathSegments = window.location.pathname.split('/').filter(Boolean);
tenantAxiosInstance.interceptors.response.use(
  (response) => {
    console.log(response, "response inside this tenantAxiosInstance");
    if ((response?.response?.data?.detail == "Session expired please login again") || (response?.response?.data?.detail == "Invalid credentials")) {

      sessionStorage.removeItem('persist:root');

      sessionStorage.removeItem('brandUser');
      const loginRedirect = isProdEnv
        ? '/login'
        : pathSegments.length > 0
          ? `/${pathSegments[0]}/login`
          : '/login';

      window.location.href = loginRedirect;
    }
    return response;
  },
  (error) => {
    console.log(error, "error inside this tenantAxiosInstance");
    if ((error?.response?.data?.detail == "Session expired please login again") || (error?.response?.data?.detail == "Invalid credentials") || (error?.response?.data?.detail == "user is inactive. user have been logged out.") ) {

      sessionStorage.removeItem('persist:root');

      sessionStorage.removeItem('brandUser');
      const loginRedirect = isProdEnv
        ? '/login'
        : pathSegments.length > 0
          ? `/${pathSegments[0]}/login`
          : '/login';

      window.location.href = loginRedirect;
    }
    const authToken = JSON.parse(
      sessionStorage.getItem('brandUser')
    )?.access_token;

    if (!isTokenValid(authToken)) {
      sessionStorage.removeItem('persist:root');

      sessionStorage.removeItem('brandUser');
      const loginRedirect = isProdEnv
        ? '/login'
        : pathSegments.length > 0
          ? `/${pathSegments[0]}/login`
          : '/login';

      window.location.href = loginRedirect;
    }
    return Promise.reject(error);
  }
);

export default tenantAxiosInstance;
